import { action } from 'easy-peasy';
import { IActionSetActTeamsShowAll } from '../types';

const setActTeamsShowAll: IActionSetActTeamsShowAll = action((state, payload) => {
  state.actTeamsShowAll = payload;
});

export default setActTeamsShowAll;
